import React from 'react';
import './Privacy.css';

const PrivacyPage = () => {
  return (
    <div className="privacy-page">
      {/* Header Section with breadcrumb style */}
      <div className="header-section">
        <div className="container">
          <div className="header-content">
            <h1 className="main-title">Our Privacy Policy</h1>
          </div>
          
          {/* Welcome paragraph */}
          <div className="welcome-section">
            <p className="welcome-text">
              Thank you for being part of Peak Mobile! We are committed to protecting your personal information and your right to privacy. 
              If you have any questions or concerns about this privacy notice, or our practices with regards to your personal information, 
              please contact us at{' '}
              <a 
                href="mailto:chat@peakmobile.co.ke" 
                className="email-link"
              >
                chat@peakmobile.co.ke
              </a>
            </p>
          </div>
        </div>
      </div>

      {/* PDF Viewer Section */}
      <div className="pdf-section">
        <div className="container">
          <div className="pdf-container">
            <iframe
              src="/privacy-policy2.pdf"
              className="pdf-iframe"
              title="Privacy Policy Document"
            >
              <div className="pdf-fallback">
                <p className="fallback-text">
                  Your browser doesn't support PDF viewing. 
                </p>
                <a 
                  href="/privacy-policy2.pdf" 
                  download
                  className="download-btn"
                >
                  Download Privacy Policy PDF
                </a>
              </div>
            </iframe>
          </div>
        </div>
      </div>



    
    </div>
  );
};

export default PrivacyPage;